import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "branchSlice",
    initialState: {
        baranchAuthDetails: [],
        authBranchDetailsForm: [],
        editFlag: false,
        branchAuthFurtherDetails: [],
    },
    reducers: {
        SETBRANCHAUTHFORMDATA_SUCCESS: (state, action) => {
            return {
                ...state,
                authBranchDetailsForm: action.payload,
                editFlag: true,
            };
        },

        SETBRANCHAUTHFORMDATA_ERROR: (state) => {
            return {
                ...state,
                authBranchDetailsForm: [],
            };
        },
        SETBRANCHAUTHFORMDATA_NULL_SUCCESS: (state, action) => {
            return {
                ...state,
                authBranchDetailsForm: [],
            };
        },
        SETEDITFLAG_SUCCESS: (state, action) => {
            return {
                ...state,
                editFlag: action.payload,
            };
        },
        GETBRANCHAUTHORIZATION_SUCCESS: (state, action) => {
            return {
                ...state,
                baranchAuthDetails: action.payload,
            };
        },
        GETBRANCHAUTHORIZATION_ERROR: (state) => {
            return {
                ...state,
                baranchAuthDetails: [],
            };
        },

        GETBRANCHAUTHFURTHERDETAILS_SUCCESS: (state, action) => {
            return {
                ...state,
                branchAuthFurtherDetails: action.payload?.authMatrixDetails,
            };
        },
        GETBRANCHAUTHFURTHERDETAILS_ERROR: (state) => {
            return {
                ...state,
                branchAuthFurtherDetails: "",
            };
        },
    },
});

export const { SETBRANCHAUTHFORMDATA_SUCCESS, SETBRANCHAUTHFORMDATA_ERROR, SETBRANCHAUTHFORMDATA_NULL_SUCCESS, SETEDITFLAG_SUCCESS, GETBRANCHAUTHORIZATION_SUCCESS, GETBRANCHAUTHORIZATION_ERROR, GETBRANCHAUTHFURTHERDETAILS_SUCCESS, GETBRANCHAUTHFURTHERDETAILS_ERROR } = slice.actions;
export default slice.reducer;
